function pluralize(str, count, postfix = "er") {
  return count === 1 ? str : `${str}${postfix}`;
}

export { pluralize };
//# sourceMappingURL=string.plural.js.map
